// EXPORT
export default $target => {
  // 表示中ページの地域
  const countrycode = location.pathname.split('/')[2]; // eslint-disable-line

  Array.prototype.forEach.call($target, dom => {
    // 指定されている値を取得
    const country = dom.getAttribute('data-countrycode').split(',');
    // 否定判定があるか確認
    let disable = false;
    Array.prototype.forEach.call(country, item => {
      if (item.match(/^!/g)) disable = true;
    });
    // 判定
    let valid;
    if (!disable) {
      // 一致する国でだけ表示
      valid = false;
      Array.prototype.forEach.call(country, item => {
        if (item === countrycode) valid = true;
      });
    } else {
      // 一致しない国でだけ表示
      valid = true; // eslint-disable-line

      Array.prototype.forEach.call(country, item => {
        if (item.substr(1) === countrycode) valid = false;
      });
    }
    dom.setAttribute('aria-hidden', !valid);
  });
};
